import { Button, Card, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAuthContext } from 'src/auth/hooks';
import { createPrescreeningQues } from 'src/services/role.service';
import { getOrganizationId } from 'src/services/user.service';
import CreatePrescreeningQues from '../job/forms/create-prescreening-ques';
import { PrescreeningQuestionsTable } from '../job/forms/pre-screening';

const QuestionsDescription = ({
  preScreenEditAllowed,
  prescreenQuestions,
  setPrescreenQuestions,
  role_id,
}) => {
  const { user } = useAuthContext();
  const organization_id = getOrganizationId(user);

  const [currentQuestion, setCurrentQuestion] = useState(null);

  // Prescreening question create form
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setCurrentQuestion(null);
    setOpen(false);
  };

  useEffect(() => {
    const caller = async () => {
      const questionsDum = prescreenQuestions.map((item, index) => ({
        ...item,
        sl_no: index + 1,
      }));

      const payload = { questions: questionsDum };
      console.log(payload);
      const res = await createPrescreeningQues(
        payload,
        organization_id,
        role_id,
      );
      console.log(res);
    };
    caller();
  }, [prescreenQuestions]);

  return (
    <>
      <Stack>
        <CreatePrescreeningQues
          open={open}
          handleClose={handleClose}
          questions={prescreenQuestions}
          setQuestions={setPrescreenQuestions}
          currentQuestion={currentQuestion}
          setCurrentQuestion={setCurrentQuestion}
        />
      </Stack>

      <Stack component={Card} spacing={3} sx={{ p: 3, mb: '2rem' }}>
        <Stack direction="row">
          <Typography sx={{ flexGrow: 1 }} variant="h4">
            Prescreening Questions
          </Typography>
          <Button
            size="small"
            onClick={handleOpen}
            sx={{ width: '5rem', border: '1px solid grey' }}
            variant="contained"
            disabled={!preScreenEditAllowed}
          >
            <span
              style={{
                fontSize: '1.5rem',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                marginRight: '5px',
              }}
            >
              +
            </span>{' '}
            Add
          </Button>
        </Stack>

        <Stack sx={{ minHeight: '5rem' }}>
          <PrescreeningQuestionsTable
            preScreenEditAllowed={preScreenEditAllowed}
            questions={prescreenQuestions}
            setQuestions={setPrescreenQuestions}
            setCurrentQuestion={setCurrentQuestion}
            handleOpen={handleOpen}
          />
        </Stack>

        {/* <Form form={form} layout="vertical" onFinish={handleSave}>
                    {role?.pre_screen_questions.map((question, index) => (
                      <Form.Item
                        key={index}
                        label={`Question ${index + 1}`}
                        name={index}
                      >
                        <Typography variant="h6">{question.text}</Typography>
                      </Form.Item>
                    ))}
                  </Form> */}
      </Stack>
    </>
  );
};

export default QuestionsDescription;
